import { createFileRoute, redirect } from '@tanstack/react-router'

import { accountEmailVerifyConfirmRetrieve } from '@/api/gen'
import { RootRoute } from '@/pages/auth/route-entries/code'
import {
  defaultAuthQuery,
  defaultTokenVerificationQuery,
  tokenVerificationSchema,
} from '@/pages/auth/search-schema'

export const Route = createFileRoute('/_auth/login/verify-email/code')({
  component: RootRoute,
  validateSearch: (search) =>
    tokenVerificationSchema.catch(defaultTokenVerificationQuery).parse(search),
  loaderDeps: ({ search }) => {
    return { search }
  },
  loader: async ({ deps: { search } }) => {
    let status: 'success' | 'error' = 'success'
    if (search.uidb64 === '' || search.token === '') {
      console.error('Missing uidb64 and token in search parameters')

      throw redirect({
        to: '/login',
        search: {
          ...defaultAuthQuery,
          type: 'implicit',
        },
        replace: true,
      })
    }
    try {
      await accountEmailVerifyConfirmRetrieve(search.uidb64, search.token)
    } catch (error) {
      console.error('Error while verifying email:', error)
      status = 'error'
    }

    return {
      status,
    }
  },
})
